import internalSharedConfig from './internalSharedConfig';

/**
 * This file was automatically generated. Do not modify it by hand.
 * Instead, modify the shared config (on Strapi or internal) and run `yarn sync:sharedConfig && yarn sync:sharedConfig:prettier`.
 */
const strapiSharedConfig = {
  featherName: 'Feather Insurance',
  privateHealthInsuranceThreshold: 73800,
  miniJobThreshold: 6672,
};
export const sharedConfig = { ...strapiSharedConfig, ...internalSharedConfig };
